import { Location as LocationAngular } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router, Params } from '@angular/router';

import { Store } from '@ngrx/store';

import { environment } from '@env/environment';

import { LOCATION } from '@personal-area/common';
import { Logout } from '@personal-area/global/state';
import { CryptoStorageService, SESSION_STORAGE } from '@personal-area/storage';

const redirectKey = 'redirect-back-url';

@Injectable({ providedIn: 'root' })
export class RedirectBackService {

  private readonly _deniedLocations = [
    /^\/(logout|login)/,
    /^\/registration/,
    /^\/recovery/,
  ];

  constructor(
    private _router: Router,
    private _cryptoStorageService: CryptoStorageService,
    private _store: Store,
    private _locationAngular: LocationAngular,
    @Inject(LOCATION) private _locationNative: Location,
    @Inject(SESSION_STORAGE) private _sessionStorage: Storage,
  ) {
  }

  public get nextUrl(): string {
    return this.hasRedirectUrl()
      ? decodeURIComponent(this._cryptoStorageService.getItem(redirectKey, this._sessionStorage))
      : '';
  }

  public isDenied(path: string): boolean {
    return !!this._deniedLocations.find(loc => !!path.match(loc));
  }

  public storeCurrentLocation(url?: string): string {
    const l = url
      || this._locationNative.pathname.replace(/^\/cabinet/, '')
      + this._locationNative.search
      + this._locationNative.hash;

    if (!this.isDenied(l)) {
      this._cryptoStorageService.setItem(redirectKey, encodeURIComponent(l), this._sessionStorage);
    }

    return l;
  }

  public hasRedirectUrl(): boolean {
    return !!this._cryptoStorageService.getItem(redirectKey, this._sessionStorage);
  }

  public clear(): void {
    this._cryptoStorageService.removeItem(redirectKey, this._sessionStorage);
  }

  public redirect(): void {
    const url = this._cryptoStorageService.getItem(redirectKey, this._sessionStorage);

    this.clear();

    if (url && !this.isDenied(url)) {
      this._router.navigateByUrl(decodeURIComponent(url));
    } else {
      this._router.navigate([environment.redirectURLAfterLogin]);
    }
  }

  public redirectLogin(): void {
    const currentUrl = this.storeCurrentLocation();
    const queryParams
      = Object.fromEntries(new URLSearchParams(this._locationNative.search));

    this._router.navigate(['/login'], {
      queryParams,
      skipLocationChange: true
    });
    this._store.dispatch(Logout());
    this._locationAngular.replaceState(currentUrl);
  }

}
